import { api, API_ENDPOINTS } from '../lib/api';
import { GenerateInvoiceRequest, InvoiceResponse } from '../types';

/**
 * Invoice Service
 * Handles invoice retrieval and generation for wallet recharges
 */
export const invoiceService = {
  /**
   * Get invoice by wallet transaction ID
   */
  getByWalletTransactionId: async (walletTransactionId: string): Promise<InvoiceResponse> => {
    const response = await api.get<InvoiceResponse>(
      API_ENDPOINTS.INVOICES.BY_WALLET_TRANSACTION_ID(walletTransactionId)
    );
    return response.data;
  },

  /**
   * Generate invoice from wallet recharge
   */
  generateFromRecharge: async (data: GenerateInvoiceRequest): Promise<InvoiceResponse> => {
    const response = await api.post<InvoiceResponse>(
      API_ENDPOINTS.INVOICES.GENERATE_FROM_RECHARGE,
      data
    );
    return response.data;
  },

  /**
   * Get or generate invoice for a wallet recharge
   * Tries to fetch existing invoice first, generates new one if not found (404)
   */
  getOrGenerateInvoice: async (walletTransactionId: string): Promise<InvoiceResponse> => {
    try {
      return await invoiceService.getByWalletTransactionId(walletTransactionId);
    } catch (error: any) {
      if (error.response?.status === 404) {
        return await invoiceService.generateFromRecharge({ walletTransactionId });
      }
      throw error;
    }
  },
};
